export default __webpack_public_path__ + "static/media/down-arrow.98c8fcdb.png";